import { z } from "zod";

// Passenger types
export const PASSENGER_TYPES = {
  ADULT: "adult", // Yetişkin (18+)
  STUDENT: "student", // Öğrenci (12-24 yaş)
  CHILD: "child", // Çocuk (2-11 yaş)
  INFANT: "infant", // Bebek (2 yaş altı)
  ELDERLY: "elderly", // Yaşlı (65 ve üstü)
};

// Cabin classes
export const CABIN_CLASSES = {
  ECONOMY: "economy",
  BUSINESS: "business",
};

// Passenger counts schema
export const passengerCountsSchema = z
  .object({
    [PASSENGER_TYPES.ADULT]: z.number().min(0).max(7),
    [PASSENGER_TYPES.STUDENT]: z.number().min(0).max(7),
    [PASSENGER_TYPES.CHILD]: z.number().min(0).max(7),
    [PASSENGER_TYPES.INFANT]: z.number().min(0).max(7),
    [PASSENGER_TYPES.ELDERLY]: z.number().min(0).max(7),
  })
  .refine(
    (data) => {
      // Bebek yolcular hariç en fazla 7 yolcu
      const totalNonInfant =
        data.adult + data.student + data.child + data.elderly;
      return totalNonInfant <= 7;
    },
    {
      message: "Bebek yolcular hariç en fazla 7 yolcu seçilebilir",
      path: ["general"],
    },
  )
  .refine(
    (data) => {
      // En az bir yetişkin, öğrenci veya yaşlı yolcu bulunması zorunlu
      const responsibleAdults = data.adult + data.student + data.elderly;
      return responsibleAdults >= 1;
    },
    {
      message:
        "En az bir yetişkin, öğrenci veya yaşlı yolcu bulunması zorunludur",
      path: ["adult"],
    },
  )
  .refine(
    (data) => {
      // Bebek yolcular tek başına seyahat edemez
      if (data.infant > 0) {
        const responsibleAdults = data.adult + data.elderly;
        return responsibleAdults >= 1;
      }
      return true;
    },
    {
      message:
        "Bebek yolcular en az bir yetişkin veya yaşlı yolcu ile birlikte uçmalıdır",
      path: ["infant"],
    },
  )
  .refine(
    (data) => {
      // Çocuk yolcuların seyahat edebilmesi için şart
      if (data.child > 0) {
        const responsibleAdults = data.adult + data.student + data.elderly;
        return responsibleAdults >= 1;
      }
      return true;
    },
    {
      message:
        "Çocuk yolcuların seyahat edebilmesi için en az bir yetişkin, öğrenci veya yaşlı yolcu bulunmalıdır",
      path: ["child"],
    },
  )
  .refine(
    (data) => {
      // Bebek sayısı yetişkin + yaşlı sayısını geçemez (her yetişkin/yaşlı en fazla 1 bebek alabilir)
      const responsibleForInfants = data.adult + data.elderly;
      return data.infant <= responsibleForInfants;
    },
    {
      message:
        "Her yetişkin/yaşlı yolcu en fazla bir bebek ile seyahat edebilir",
      path: ["infant"],
    },
  );

// Full passenger and cabin class schema
export const passengerSelectionSchema = z.object({
  passengers: passengerCountsSchema,
  cabinClass: z.enum([CABIN_CLASSES.ECONOMY, CABIN_CLASSES.BUSINESS]),
});

// Default values
export const defaultPassengerCounts = {
  [PASSENGER_TYPES.ADULT]: 1,
  [PASSENGER_TYPES.STUDENT]: 0,
  [PASSENGER_TYPES.CHILD]: 0,
  [PASSENGER_TYPES.INFANT]: 0,
  [PASSENGER_TYPES.ELDERLY]: 0,
};

export const defaultCabinClass = CABIN_CLASSES.ECONOMY;
